import { isPDF } from "@/apiUtils/commonUtils";
import IconCamera from "@/assets/icons/camera.svg?react";
import { PrescriptionData, TranslationData } from "@/common/lib/types";
import Button from "@/components/ui/button/Button";
import { MouseEventHandler, useState } from "react";
import UploadedItem from "../../phaseOne/prescription/upload/UploadedItem";
import EditTitle from "./EditTitle";
import { getCloudinaryURL } from "@/utils/cloudinary";

interface IProps {
  hideDelete?: boolean;
  translations: TranslationData;
  prescription?: PrescriptionData;
  handleToggleUploadMenu: () => void;
  handleDelete?: (id: string) => Promise<void>;
  handleEdit?: (data?: PrescriptionData) => Promise<void>;
}

const TakeOrUpload = ({
  handleEdit,
  hideDelete,
  prescription,
  handleDelete,
  translations,
  handleToggleUploadMenu,
}: IProps) => {
  const [openEditTitleModal, setOpenEditTitleModal] = useState(false);

  const handleToggleEdit: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setOpenEditTitleModal((state) => !state);
  };

  const handleLocalEdit = async (title: string) => {
    if (!prescription || typeof handleEdit !== "function") return;
    await handleEdit({ ...prescription, title });
  };

  const handleLocalDelete = async () => {
    if (typeof handleDelete !== "function" || !prescription) return;
    await handleDelete(prescription.id);
    setOpenEditTitleModal(false);
  };

  const imgUrl = getCloudinaryURL(prescription?.images?.at(0)?.url ?? "") || "";

  console.log("url--->>", imgUrl);

  return (
    <div className="w-full border">
      <button
        disabled={!!prescription}
        onClick={handleToggleUploadMenu}
        className="flex w-full cursor-pointer items-center disabled:cursor-not-allowed"
      >
        <div className="flex w-16 shrink-0 self-stretch items-center justify-center border-r min-h-[4rem]">
          <IconCamera />
        </div>
        <div className="w-full bg-tertiary-3 p-4 text-start">
          <h3 className="text-[0.75rem] font-semibold sm:text-sm">
            {translations?.lensConfigurator?.lens_config_review_section_take_photo_title}
          </h3>
          <p className="text-[0.75rem] text-tertiary-6">
            {translations?.lensConfigurator?.lens_config_review_section_take_photo_subtitle}
          </p>
        </div>
      </button>

      {prescription && (
        <div className="w-full border-t p-5 pt-0">
          <div className="mt-5 w-full">
            <div className="mb-1 flex items-center gap-2">
              <h3 className="text-sm">{prescription.title}</h3>
              <Button
                variant="link"
                onClick={handleToggleEdit}
                className="text-sm font-normal text-tertiary-6 sm:text-sm md:text-sm"
              >
                Edit
              </Button>
            </div>
            <UploadedItem
              initialProgress={100}
              hideDelete={hideDelete}
              translations={translations}
              onRemove={handleLocalDelete}
              file={{
                name: prescription.title,
                previewURL: imgUrl,
              }}
            />
          </div>
        </div>
      )}
      {prescription && (
        <EditTitle
          name={prescription.title}
          isOpen={openEditTitleModal}
          translations={translations}
          handleEdit={handleLocalEdit}
          onClose={() => setOpenEditTitleModal(false)}
        />
      )}
    </div>
  );
};

export default TakeOrUpload;
